import { SetGetShift } from './thunk/setGetShift';

export const Thunks = {
    SetGetShift
}